module.exports = __webpack_public_path__ + "static/img/02.6321625.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour3/02.jpg
// module id = WBxY
// module chunks = 0